import 'core-js/modules/es.array.map';
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.string.replace';
import 'core-js/modules/es.string.split';
import { isPlainObject } from 'is-plain-object';
import { assert, assertType } from 'yaassertion';
import LRU from 'lru-cache';

var Globalize = require('globalize/dist/globalize');

/**
 * Given a locale, it  will return certain old locales to new form
 * @param {locale} locale to replace
 * @return {new_locale}
 */
function normalizeLocale(locale) {
  // prettier-ignore
  return locale.replace(/\bno\b/, "nb").replace(/\btl\b/, "fil");
}
var countryAliasMapping = {
  C2: "CN",
  UK: "GB"
};
function getResolvedRegion(region) {
  return countryAliasMapping[region] || region;
}
var ENVIRONMENT = {
  PRODUCTION: "production"
};

/**
 * max: maximum number of keys that the cache can have
 * ttl: time to live in milliseconds (currently it's set to 10 minutes)
 */
var DEFAULT_CACHE_CONFIG = {
  max: 400,
  ttl: 10 * 60 * 1000
};

/**
 * Wrapper for LRU cache that can be used across worldready sdk.
 */
var Cache = /*#__PURE__*/function () {
  function Cache(options) {
    if (options === void 0) {
      options = {};
    }
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assertType(options, "options", ["plain object"]);
    }
    options = Object.assign({}, DEFAULT_CACHE_CONFIG, options);
    this.cache = new LRU(options);
  }

  /**
   * Utility function to set the value in cache.
   * @param {String} key string value that should be used as cache key
   * @param {Any} value value that needs to be stored in cache (can be string, number, object, etc.)
   * @param {Object} options an optional object that can have following props:
   *  size
   *  sizeCalculation
   *  ttl
   *  noDisposeOnSet
   *  start
   * For more details, refer this link: https://github.com/isaacs/node-lru-cache#setkey-value--size-sizecalculation-ttl-nodisposeonset-start-
   * @returns {Any} value that's added to the cache
   */
  var _proto = Cache.prototype;
  _proto.set = function set(key, value, options) {
    if (options === void 0) {
      options = {};
    }
    return this.cache.set(key, value, options);
  }

  /**
   * Utility function to retrieve a value from cache.
   * @param {String} key string value that was used as key while entering the value in cache
   * @param {Object} options an optional object that can have following props:
   *  updateAgeOnGet
   *  allowStale
   * For more details, refer this link: https://github.com/isaacs/node-lru-cache#getkey--updateageonget-allowstale-----value
   * @returns {Any} value that's stored in cache for the corresponding key. It'll return undefined if key is not found.
   */;
  _proto.get = function get(key, options) {
    if (options === void 0) {
      options = {};
    }
    return this.cache.get(key, options);
  }

  /**
   * Utility function to check if value for a certain key is present in cache or not.
   * @param {*} key string value that could've been used as key while entering the value in cache
   * @param {*} options an optional object that can have following props:
   *  updateAgeOnHas: if set to false, the recency of the key won't be updated
   * @returns {Boolean}
   */;
  _proto.has = function has(key, options) {
    if (options === void 0) {
      options = {};
    }
    return this.cache.has(key, options);
  }

  /**
   * Utility function to delete a key from cache.
   * @param {String} key string value that was used as key while entering the value in cache
   * @returns {Boolean} true if key was found, otherwise false
   */;
  _proto.delete = function _delete(key) {
    return this.cache.delete(key);
  }

  /**
   * Utility function to get total number of items present in cache.
   */;
  _proto.size = function size() {
    return this.cache.size;
  }

  /**
   * Helper function to clear contents of cache.
   */;
  _proto.clear = function clear() {
    return this.cache.clear();
  };
  return Cache;
}();
require("./globalize-overrides/relative-time");
require("./globalize-overrides/unit");
require("./globalize-overrides/date");

// Internationalization and localization data providers array:
var isWorldReadyLoadCalled;
var isWorldReadyInstance = function isWorldReadyInstance(object) {
  return object && object.globalize;
};
function _normalizeLocale(locale, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$langSubtag = _ref.langSubtag,
    langSubtag = _ref$langSubtag === void 0 ? true : _ref$langSubtag;
  if (locale.payPalLocaleCode) {
    // A payPalLocaleCode to existing limited locale support.
    var _locale$payPalLocaleC = locale.payPalLocaleCode,
      _locale = _locale$payPalLocaleC.locale,
      _country = _locale$payPalLocaleC.country;
    var _locale$split = _locale.split(/[-_]/),
      _localeLanguage = _locale$split[0];
    locale = _localeLanguage + "-" + _country;

    // A payPalLocaleCode to standard locale normalization: (when PayPal supports all locales anywhere)
    // const { locale: _locale } = locale.payPalLocaleCode;
    // const [_localeLanguage, _localeCountry] = _locale.split(/[-_]/);
    // if (_localeCountry === "XC") {
    //   if (_localeLanguage === "es") {
    //     // es_XC -> es-MX
    //     locale = "es-MX";
    //   } else {
    //     // fr_XC -> fr
    //     // zh_XC -> zh
    //     locale = _localeLanguage;
    //   }
    // } else {
    //   locale = _locale;
    // }
  }
  if (process.env.NODE_ENV !== "production") {
    assert(typeof locale === "string", typeof locale === "object" ? "Invalid locale {{locale}}. Did you mean {{didYouMean}}?" : "Invalid locale {{locale}}", {
      locale: locale,
      didYouMean: {
        payPalLocaleCode: locale
      }
    });
  }
  locale = locale
  // Support both _ & - as locale separator.
  // Note: This must precede other replaces using `\b`.
  .replace(/_/, "-")
  // If locale includes C2, replace it with CN-xbord
  .replace(/\bC2\b/, "CN-xbord");
  if (langSubtag) {
    locale = normalizeLocale(locale);
  }
  return locale;
}

/**
 * Region
 */
var Region = /*#__PURE__*/function () {
  function Region() {}
  Region.getRegionString = function getRegionString(worldReadyOrRegionOrString) {
    if (worldReadyOrRegionOrString && worldReadyOrRegionOrString.region) {
      return getResolvedRegion(worldReadyOrRegionOrString.region);
    }
    return getResolvedRegion(worldReadyOrRegionOrString);
  };
  return Region;
}();
if (process.env.NODE_ENV !== "production") {
  Region.assertType = function (parameterValue, parameterName) {
    assertType(parameterValue, parameterName, ["string", "object"]);
  };
}

/**
 * WorldReady
 */
var _WorldReady = function WorldReady(locale) {
  var _main;
  if (process.env.NODE_ENV !== "production") {
    assert(isWorldReadyLoadCalled, "Load WorldReady metadata first. Please read " + "https://github.paypal.com/pages/Globalization-R/worldready-js" + "/about-load-worldready-data.html");
  }
  if (!(this instanceof _WorldReady)) {
    return new _WorldReady(locale);
  }

  // TODO assert locale
  locale = _normalizeLocale(locale);

  // Hack: set any locale as available locale.
  Globalize.load({
    main: (_main = {}, _main[locale] = {}, _main)
  });
  this.globalize = new Globalize(locale);
  var cldr = this.globalize.cldr;
  this.bundle = cldr.attributes.bundle;
  this.locale = cldr.locale;
  this.language = cldr.attributes.language;
  this.region = cldr.attributes.region;
  this.market = this.region;
  this.weekInfo = {
    minDays: cldr.get(["supplemental/weekData/minDays", this.region]) || cldr.get("supplemental/weekData/minDays/001"),
    firstDay: cldr.get(["supplemental/weekData/firstDay", this.region]) || cldr.get("supplemental/weekData/firstDay/001"),
    weekendStart: cldr.get(["supplemental/weekData/weekendStart", this.region]) || cldr.get("supplemental/weekData/weekendStart/001"),
    weekendEnd: cldr.get(["supplemental/weekData/weekendEnd", this.region]) || cldr.get("supplemental/weekData/weekendEnd/001")
  };
  this.metadata = cldr.get(["metadata"]) || {};
};

/**
 * async WorldReady.load()
 */
{
  // Client-side
  _WorldReady.load = function () {
    // TODO assert params
    isWorldReadyLoadCalled = true;
    for (var _len = arguments.length, providers = new Array(_len), _key = 0; _key < _len; _key++) {
      providers[_key] = arguments[_key];
    }
    providers.map(function (provider) {
      if (isPlainObject(provider)) {
        Globalize.load(provider);
        return;
      }
      throw new Error("Oops: Async provider not supported in browsers at the moment");
    });
  };
}
_WorldReady._Globalize = Globalize;
_WorldReady.cache = new Cache();

/**
 * WorldReady features skeleton
 */
if (process.env.NODE_ENV !== "production") {
  var loadError = function loadError(feature) {
    return function () {
      throw new Error("Missing feature, you may want to `import @paypalcorp/worldready-" + feature + "`");
    };
  };
  _WorldReady.prototype.Address = loadError("address");
  _WorldReady.prototype.RelativeTimeFormat = loadError("relative-time");
  _WorldReady.prototype.MessageFormat = loadError("message");
  _WorldReady.prototype.NumberFormat = loadError("number");
  _WorldReady.prototype.CurrencyFormat = loadError("currency");
}
var Griffin = _WorldReady;

export { Griffin, Region, _WorldReady as WorldReady, _normalizeLocale, isWorldReadyInstance };
